export const checkmarkSvg = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="ock-checkmarkSvg"
  >
    <title>Checkmark SVG</title>
    <path
      d="M12.5 0C5.87 0 0.5 5.37 0.5 12C0.5 18.63 5.87 24 12.5 24C19.13 24 24.5 18.63 24.5 12C24.5 5.37 19.13 0 12.5 0ZM10.59 17.3L6.1 12.81L7.51 11.4L10.59 14.48L17.66 7.41L19.07 8.82L10.59 17.3Z"
      fill="#F9FAFB"
    />
  </svg>
);
